export function makeDragAndDroppable(element, onDrop, overlayDiv) {
  element.addEventListener('dragenter', function(e) {
    overlayDiv.style.visibility = 'visible';
    overlayDiv.style.opacity = 1;
  });

  element.addEventListener('dragleave', function(e) {
    e.preventDefault();
    if (overlayDiv) {
      overlayDiv.style.visibility = 'hidden';
      overlayDiv.style.opacity = 0;
    }
  });

  element.addEventListener('dragover', function(e) {
    e.preventDefault();
    if (overlayDiv) {
      overlayDiv.style.visibility = 'visible';
      overlayDiv.style.opacity = 1;
    }
  });

  element.addEventListener('drop', function(e) {
    e.preventDefault();
    if (overlayDiv) {
      overlayDiv.style.visibility = 'hidden';
      overlayDiv.style.opacity = 0;
    }
    if (onDrop) {
      onDrop(e);
    }
  });
}

export async function confirm({okBtnText, notOkBtntext}) {
  return new Promise((resolve, reject) => {
    buttons: [
      [
        `<button>${okBtnText}</button>`,
        resolve,
        true
      ],
      [
        `<button>${notOkBtntext}</button>`,
        reject
      ]
    ]
  })
}
